import { LinkType, EditorType } from '../../constants';
import { LinkConfig } from './getData';
import { getLinkType, getGotoPageAction, isEditableButton } from '../helpers';
import { editableId } from '../htmlEditor/constants';
import constants from '../indesignEditor/constants';

interface LinkAttributes {
	href: string;
	target: string | null;
	onclick: string | null;
	ontouchend: string | null;
	draggable: string | null;
}

const updateAttributes = (element: HTMLAnchorElement, attributes: LinkAttributes) => {
	Object.entries(attributes).forEach(([key, value]) => {
		if (value) {
			element.setAttribute(key, value);
		} else {
			element.removeAttribute(key);
		}
	});
};

export default (htmlDocument: HTMLDocument, links: LinkConfig[], editorType: EditorType) => {
	links.forEach(({
		isEditedFromBackoffice,
		id,
		href,
	}) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		const linkSelector = editorType === EditorType.INDESIGN
			? `#${id}`
			: `[${editableId}=${id}]`;
		const element = htmlDocument.querySelector(linkSelector);
		const linkElement = element && element.closest('a') as HTMLAnchorElement;

		if (linkElement) {
			const linkType = getLinkType(href);
			const isUrlLink = linkType === LinkType.url;
			const attributes: LinkAttributes = {
				href: isUrlLink ? href : 'javascript:void(0)',
				target: isUrlLink ? '_blank' : null,
				onclick: isUrlLink ? null : getGotoPageAction(href),
				ontouchend: isUrlLink ? null : getGotoPageAction(href),
				draggable: isUrlLink ? null : 'false',
			};

			updateAttributes(linkElement, attributes);

			if (isEditableButton(linkElement)) {
				const parentLinkElement = linkElement.closest(`[id*=${constants.parentContainerId}]`) as HTMLElement;

				if (parentLinkElement) {
					parentLinkElement.classList.add(constants.editableButtonClassName);
				}
			}
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableLinks/saveData.ts